import {Component, Vue, Prop} from 'vue-facing-decorator';
import { ref } from "vue";

import SideBarMenuItem from './SideBarMenuItem/SideBarMenuItem.vue';


@Component({
    name : 'app-sidebar-menu',
    components: {
        'app-side-item' : SideBarMenuItem
    }
})
export default class SideBarMenu extends Vue {
    @Prop() app_base_data = ref([]);
    @Prop() item_side_menu = ref([]);
    
    get user(): any {
        return this.$store.getters['user/getUser'];
    }
}   